import { signal } from '@angular/core';

export interface AiQuestion {
  id: number;
  question: string;
  answer: string;
  status: 'new' | 'processing' | 'completed' | 'error';
}

export interface AiList {
  list: AiQuestion[];
  count: number;
}

export interface AiGetParams {
  query?: string;
  limit: number;
  offset: number;
}

export class AiQuestionUi {
  isAnimated = signal<boolean>(false);
  isExpanded = signal<boolean>(false);
  data: AiQuestion;

  constructor(public aiQuestion: AiQuestion) {
    this.data = aiQuestion;
  }

  get id() {
    return this.data.id;
  }

  get status() {
    return this.data.status;
  }

  get question() {
    return this.data.question;
  }

  get answer() {
    return this.data.answer;
  }
}
